import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { colors, H1, useContainerWidth } from '@fs/zion-ui'
import { useNavigate } from '../../hooks'

// #region Styles
// NOTE: This font border helps the text contrast enough from the background color to pass A11y requirements.
const cssFontBorder = css`
  text-shadow:
    ${colors.yellow40} 0 0 1px,
    ${colors.yellow40} 0 0 1px,
    ${colors.yellow40} 0 0 1px,
    ${colors.yellow40} 0 0 1px;
`
// #endregion

/**
 * @describe - This renders the dynamically sized header for the Role Indicator demo.
 * NOTE: Defining this as its own components was easier to avoid infinite rerender loops than defining it in App.js.
 */
export default function RoleIndicatorHeader() {
  const [t] = useTranslation()
  const { location } = useNavigate()
  const isChooseYourDemo = location.pathname === '/choose-your-demo'
  const isLcrDemo = location.pathname.includes('lcr-demo')
  const headerSize = useContainerWidth()({ default: 'H6', xs: 'H5', sm: 'H4', lg: 'H3' })

  let tryDemoRoleIndicatorTitleText = t('tryDemo.fna.role-indicator-title-text', 'Demo: Family Name Assist')
  if (isLcrDemo) {
    tryDemoRoleIndicatorTitleText = t('tryDemo.lcr.role-indicator-title-text', 'Demo: Leader and Clerk Resources (LCR)')
  } else if (isChooseYourDemo) {
    tryDemoRoleIndicatorTitleText = t(
      'tryDemo.choose-your-demo.role-indicator-title-text',
      'Demo: Family Name Assist / Leader and Clerk Resources (LCR)'
    )
  }

  return (
    <H1 size={headerSize} supplementary>
      <div css={cssFontBorder}>{tryDemoRoleIndicatorTitleText}</div>
    </H1>
  )
}
